export default [
  {
    path: '/saidas',
    name: 'Saidas',
    component: () => import(/* webpackChunkName: "Saidas" */ '../saidas/Saidas')
  },
  {
    path: '/saidas-cadastro',
    name: 'SaidasCadastro',
    component: () => import(/* webpackChunkName: "SaidasCadastro" */ '../saidas/SaidasCadastro')
  },
  {
    path: '/saidas-lista',
    name: 'SaidasLista',
    component: () => import(/* webpackChunkName: "SaidasLista" */ '../saidas/SaidasLista')
  }
]



// WEBPACK FOOTER //
// ./src/pages/saidas/router.js